module.exports = __webpack_public_path__ + "img/right_arrow_icon.6fd1a056.svg";